module.exports = __webpack_public_path__ + "img/red.77f0fb9a.png";